var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross",
    transform: "translate(-1337.054 -11.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    transform: "translate(1337.054 11.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M1354.128,14.317a10,10,0,1,0,0,14.149A10.016,10.016,0,0,0,1354.128,14.317Zm-2.948,10.022A.834.834,0,0,1,1350,25.518l-2.947-2.948-2.946,2.947a.834.834,0,1,1-1.179-1.179l2.946-2.947-2.947-2.947a.834.834,0,1,1,1.179-1.179l2.947,2.947L1350,17.265a.834.834,0,0,1,1.179,1.179l-2.947,2.947Z",
    transform: "translate(-1337.054 -11.391)",
    fill: "#6c5b7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8d0fb5557f7b357acf7ff971276ed18d.svg";
export { ForwardRef as ReactComponent };